import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { NewsFeedWidget } from '@/components/dashboard';

export default function NewsFeed() {
    return (
        <DashboardLayout>
            <div className="space-y-4" data-testid="news-feed-page">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-outfit font-semibold text-slate-900">Fil d'actualité</h1>
                    <p className="text-slate-500 mt-1 text-sm">Les dernières publications de Valnexo et de vos équipes.</p>
                </div>
                <NewsFeedWidget forceExpanded />
            </div>
        </DashboardLayout>
    );
}
